import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'

const CardPriceWrapper = ({ children }) => {
  const isResponsiveEnabled = useContext(IsResponsiveEnabledContext)
  const DefaultPriceWrapper = () =>
    <div className='card-price col-12 mt-1 mb-1 color-brand-1 p-0'>
      {children}
    </div>

  return (
    isResponsiveEnabled ? (
      <Fragment>
        <MediaQuery minDeviceWidth={426}>
          <DefaultPriceWrapper />
        </MediaQuery>
        <MediaQuery maxDeviceWidth={425}>
          <div className='card-price mt-2 col-12 color-brand-1 p-0'>
            {children}
          </div>
        </MediaQuery>
      </Fragment>
    ) : <DefaultPriceWrapper />
  )
}

CardPriceWrapper.propTypes = {
  children: PropTypes.elementType
}

export default CardPriceWrapper



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/CardPriceWrapper.js